import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'col-modal-token',
  templateUrl: './modal-token.component.html',
  styleUrls: ['./modal-token.component.scss']
})
export class ModalTokenComponent implements OnInit {

  model: string;

  @Input()
  set valor(valor: string) {    
    this.model = valor;   
    switch (this.model) {
      case 'PagSeguro':          
          return
    }      
  }

  constructor() { }

  ngOnInit() {
  }
  

}



// WEBPACK FOOTER //
// ./src/app/estabelecimentos/modal-token/modal-token.component.ts